import React from 'react'
import useStore from '../../store'
import { OrganizationTypeEnum } from '../../api/organizations'

interface WorkerLabelProps {
  plural?: boolean
  potentialPlural?: boolean
  label?: string
  lowercase?: boolean
}

const WorkerLabel: React.FC<WorkerLabelProps> = ({ plural, potentialPlural, label, lowercase }) => {
  const currentOrganization = useStore(state => state.session.currentOrganization)
  let text =
    label ||
    (currentOrganization?.type === OrganizationTypeEnum.interimAgency
      ? 'Intérimaire'
      : 'Travailleur')
  if (plural) text += 's'
  else if (potentialPlural) text += '(s)'

  if (lowercase) text = text.toLowerCase()

  return <>{text}</>
}

export default WorkerLabel
